import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  OccEndpointsService,
  ProductSearchConnector,
  ProductSearchPage,
  SearchConfig,
  WindowRef,
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { GenPriceBundleResponse } from '../models/product.model';

@Injectable()
export class GenAutoShipProductsService {
  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService,
    private productSearch: ProductSearchConnector,
    private windowRef: WindowRef,
  ) { }

  search(query: string, currentPage: number, pageSize: number): Observable<ProductSearchPage> {
    const config: SearchConfig = { currentPage, pageSize };
    return this.productSearch.search(query, config);
  }

  getNetPrices(userId: string, productCodes: string[]): Observable<GenPriceBundleResponse> {
    const unitId = this.windowRef.localStorage?.getItem('companyNumber');
    const params = new HttpParams().set('codes', productCodes.join(','));
    const url = `${this.occEndpoints.getBaseUrl()}/users/${encodeURIComponent(userId)}/company/${encodeURIComponent(unitId ?? '')}/cpiPriceBundle`;

    return this.http.get<GenPriceBundleResponse>(url, { params });
  }
}
